import { CustomTextField, CustomTextFieldProps } from '@whiz-cart/ui-shared/components/customTextField.tsx';
import { debounce } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';

export interface WipTextFieldProps extends CustomTextFieldProps {
    debounce?: number;
    maxWait?: number;
}

export function WipTextField({ debounce: debounceTime = Infinity, maxWait = Infinity, onChange, ...props }: WipTextFieldProps) {
    const [value = props.value ?? '', setValue] = useState<string>();
    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    });

    const commit = useMemo(
        () =>
            debounce(
                (
                    value: string,
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>,
                ) => {
                    onChangeRef.current?.(value as string, e);
                    setValue(undefined);
                },
                debounceTime,
                { maxWait },
            ),
        [debounceTime, maxWait],
    );

    useEffect(() => {
        return () => {
            commit.cancel();
        };
    }, [commit]);

    return (
        <CustomTextField
            {...props}
            value={value}
            onChange={(value, e) => {
                if (debounceTime <= 0) {
                    onChangeRef.current?.(value, e);
                    return;
                }

                setValue(value);
                commit(value, e);
            }}
            onBlur={(e) => {
                commit.flush();
                props.onBlur?.(e);
            }}
            onClear={() => {
                commit.flush();
                props.onClear?.();
            }}
        />
    );
}
